import React from 'react';
import WorkCard from './WorkCard';

const Work = () => {
    return (
        <div>
           <div className='text-center text-3xl font-semibold text-red-500'>
            <h1>How Im Work</h1>
             </div> 
             <WorkCard></WorkCard>
        </div>
    );
};

export default Work;